(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiin-clothing-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kiin-clothing-story')) {
    customElements.define('kiin-clothing-story', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.photos = [...this.querySelectorAll('[data-story-photo]')];
        this.toggle = this.querySelector('[data-story-toggle]');
        if (this.photos.length < 2) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 750px)');
        this.index = 0;
        this.rounds = 0;
        this.userPaused = false;
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          if (!this.userPaused && this.rounds >= 3) this.rounds = 0;
          this.sync();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          this.sync();
          this.parallax();
        }, { threshold: .3 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => { this.sync(); this.parallax(); }, options);
        this.desktop.addEventListener('change', () => this.parallax(), options);
        window.addEventListener('scroll', () => {
          if (!this.inView || this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.parallax(); });
        }, { ...options, passive: true });
        this.sync();
      }
      sync() {
        clearTimeout(this.timer);
        this.toggle.hidden = this.motion.matches || !!navigator.connection?.saveData;
        const stopped = this.userPaused || this.motion.matches || navigator.connection?.saveData || this.rounds >= 3;
        this.toggle.classList.toggle('is-paused', !!stopped);
        this.toggle.setAttribute('aria-label', stopped ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.animation?.[stopped || !this.inView || document.hidden ? 'pause' : 'play']();
        if (!stopped && this.inView && !document.hidden && !this.animation) this.timer = setTimeout(() => this.advance(), 2600);
      }
      async advance() {
        const old = this.photos[this.index];
        const nextIndex = (this.index + 1) % this.photos.length;
        const next = this.photos[nextIndex];
        const img = next.querySelector('img');
        try { await img.decode(); } catch { this.sync(); return; }
        if (!this.isConnected || this.userPaused || !this.inView || document.hidden || this.motion.matches) return;
        next.style.zIndex = '2';
        this.animation = next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 750, easing: 'ease-in-out', fill: 'forwards' });
        try { await this.animation.finished; } catch { return; }
        old.classList.remove('is-current');
        old.setAttribute('aria-hidden', 'true');
        next.classList.add('is-current');
        next.removeAttribute('aria-hidden');
        this.animation.cancel();
        this.animation = null;
        next.style.removeProperty('z-index');
        this.index = nextIndex;
        this.dataset.activePhoto = String(this.index + 1);
        if (this.index === 0) this.rounds += 1;
        this.sync();
      }
      parallax() {
        if (this.dataset.desktopParallax !== 'true' || !this.desktop.matches || this.motion.matches) {
          this.style.removeProperty('--kiin-story-y');
          return;
        }
        const rect = this.getBoundingClientRect();
        const travel = Math.max(-12, Math.min(12, (window.innerHeight / 2 - rect.top - rect.height / 2) * .055));
        this.style.setProperty('--kiin-story-y', `${travel.toFixed(2)}px`);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.animation?.cancel();
      }
    });
  }

  if (!customElements.get('kiin-clothing-video')) {
    customElements.define('kiin-clothing-video', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.quietControls = this.hasAttribute('data-reveal-controls');
        if (this.quietControls) {
          this.video.controls = false;
          this.video.tabIndex = 0;
          this.keyboardFocus = false;
          const hideControls = () => {
            clearTimeout(this.controlsTimer);
            if (!this.keyboardFocus) this.video.controls = false;
          };
          const scheduleHide = () => {
            clearTimeout(this.controlsTimer);
            if (!this.video.paused && !this.keyboardFocus) this.controlsTimer = setTimeout(hideControls, 2800);
          };
          const showControls = () => {
            this.video.controls = true;
            scheduleHide();
          };
          this.addEventListener('pointerdown', showControls, options);
          this.addEventListener('pointermove', event => {
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') showControls();
          }, options);
          this.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') hideControls();
          }, options);
          this.video.addEventListener('focus', () => {
            this.keyboardFocus = this.video.matches(':focus-visible');
            showControls();
          }, options);
          this.video.addEventListener('blur', () => {
            this.keyboardFocus = false;
            hideControls();
          }, options);
          this.video.addEventListener('keydown', event => {
            this.keyboardFocus = event.key !== 'Escape';
            if (this.keyboardFocus) showControls();
            else hideControls();
          }, options);
          this.video.addEventListener('play', scheduleHide, options);
          this.video.addEventListener('seeking', () => clearTimeout(this.controlsTimer), options);
          this.video.addEventListener('seeked', scheduleHide, options);
          document.addEventListener('pointerdown', event => {
            if (!this.contains(event.target)) hideControls();
          }, options);
        }
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.completed = 0;
        this.inView = false;
        this.userPaused = false;
        const play = () => {
          if (!this.inView || document.hidden || this.userPaused || this.completed >= 3 || this.motion.matches || navigator.connection?.saveData) return;
          this.video.muted = true;
          this.video.play().catch(() => {});
        };
        this.video.addEventListener('pause', () => {
          if (this.inView && !document.hidden && !this.video.ended && !this.motion.matches) this.userPaused = true;
        }, options);
        this.video.addEventListener('play', () => { this.userPaused = false; }, options);
        this.video.addEventListener('ended', () => {
          this.completed += 1;
          play();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
          if (this.inView) play();
          else this.video.pause();
        }, { threshold: 0.35 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else play();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video.pause();
          else play();
        }, options);
      }
      disconnectedCallback() {
        this.inView = false;
        this.video?.pause();
        clearTimeout(this.controlsTimer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  function keepKiinClothingPreview() {
    if (new URL(window.location.href).searchParams.get('view') !== 'essentials-clothing') return;
    const content = document.getElementById('MainContent');
    if (!content) return;
    const keepTemplate = () => {
      for (const link of content.querySelectorAll('a[href*="/products/bamboo-"]')) {
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) continue;
        if (!/^\/products\/bamboo-(long-sleeve-bodysuit|fold-down-leggings|newborn-gown)-(sage|ivory|chocolate)$/.test(url.pathname)) continue;
        if (url.searchParams.get('view') === 'essentials-clothing') continue;
        url.searchParams.set('view', 'essentials-clothing');
        link.href = url.toString();
      }
    };
    keepTemplate();
    new MutationObserver(keepTemplate).observe(content, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', keepKiinClothingPreview, { once: true });
  } else {
    keepKiinClothingPreview();
  }

  if (!customElements.get('kiin-clothing-carousel')) {
    customElements.define('kiin-clothing-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-clothing-track]');
        if (!this.track) return;
        this.cards = [...this.track.children];
        this.track.addEventListener('click', event => {
          const choice = event.target.closest('[data-style-color]');
          if (!choice || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const card = choice.closest('[data-clothing-style]');
          const imageLink = card?.querySelector('.kiin-clothing-edit__style-image');
          const preview = choice.querySelector('template[data-color-image]')?.content.firstElementChild;
          if (!imageLink || !preview) return;
          event.preventDefault();
          if (choice.getAttribute('aria-pressed') === 'true') return;
          const image = preview.cloneNode(true);
          image.loading = 'eager';
          imageLink.querySelector('img').replaceWith(image);
          imageLink.setAttribute('aria-label', choice.dataset.colorTitle);
          card.querySelectorAll('[data-style-product-link]').forEach(link => { link.href = choice.href; });
          card.querySelector('[data-style-price]').textContent = choice.dataset.colorPrice;
          card.querySelectorAll('[data-style-color]').forEach(button => { button.setAttribute('aria-pressed', String(button === choice)); });
          card.querySelector('[data-color-status]').textContent = choice.dataset.colorAnnouncement;
        }, options);
        this.track.addEventListener('keydown', event => {
          const choice = event.target.closest('[data-style-color]');
          if (choice && event.key === ' ') { event.preventDefault(); choice.click(); }
        }, options);
        const prev = this.querySelector('[data-clothing-prev]');
        const next = this.querySelector('[data-clothing-next]');
        const current = this.querySelector('[data-clothing-current]');
        const total = this.querySelector('[data-clothing-total]');
        if (total) total.textContent = this.cards.length;
        const update = () => {
          const edge = this.track.getBoundingClientRect().left + parseFloat(getComputedStyle(this.track).paddingLeft);
          let nearest = 0;
          this.cards.forEach((card,index) => {
            if (Math.abs(card.getBoundingClientRect().left-edge) < Math.abs(this.cards[nearest].getBoundingClientRect().left-edge)) nearest = index;
          });
          const atEnd = this.track.scrollLeft >= this.track.scrollWidth-this.track.clientWidth-2;
          this.active = atEnd && this.track.scrollLeft > 0 ? this.cards.length-1 : nearest;
          if (current) current.textContent = this.active+1;
          if (prev) prev.disabled = this.track.scrollLeft < 2;
          if (next) next.disabled = atEnd;
        };
        const move = (direction) => {
          const target = this.cards[Math.max(0,Math.min(this.cards.length-1,(this.active||0)+direction))];
          if (!target) return;
          const left = target.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft-parseFloat(getComputedStyle(this.track).paddingLeft);
          this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        };
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(update);
        }, {...options,passive:true});
        prev?.addEventListener('click',()=>move(-1),options);
        next?.addEventListener('click',()=>move(1),options);
        this.track.addEventListener('keydown',(event)=>{
          if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();move(event.key==='ArrowRight'?1:-1);
        },options);
        this.querySelectorAll('[data-feature-open]').forEach(button=>{
          const dialog = this.querySelector('#'+CSS.escape(button.getAttribute('aria-controls')));
          if (!dialog) return;
          button.addEventListener('click',()=>dialog.showModal(),options);
          dialog.querySelector('[data-feature-close]')?.addEventListener('click',()=>dialog.close(),options);
          dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},options);
          dialog.addEventListener('close',()=>button.focus({preventScroll:true}),options);
        });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);
        this.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiin-hooded-towel-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('.kiin-towel-wash').forEach(root => {
      if (root.dataset.washReady) return;
      const slider = root.querySelector('.kiin-towel-wash__slider');
      const previous = root.querySelector('[data-wash-direction="-1"]');
      const next = root.querySelector('[data-wash-direction="1"]');
      if (!slider || !previous || !next) return;
      root.dataset.washReady = 'true';
      const update = () => {
        previous.disabled = slider.scrollLeft <= 5;
        next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5;
      };
      [previous, next].forEach(button => button.addEventListener('click', () => {
        slider.scrollBy({left: Number(button.dataset.washDirection) * slider.clientWidth * .8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      slider.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(slider);
      update();
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiin-mattress-protector-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;const current=new URL(location.href);if(current.searchParams.get('view')!=='mattress-protectors-preview')return;const link=event.target.closest?.('a[href]');if(!link)return;const url=new URL(link.href,location.origin);if(url.origin!==location.origin||!['/products/organic-fitted-mattress-protectors','/products/fitted-mattress-protector-organic-bassinet-co-sleeper'].includes(url.pathname))return;url.searchParams.set('view','mattress-protectors-preview');link.href=url.href;},true);
(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('.kiin-protector-sheets').forEach(root => {
      if (root.dataset.washReady) return;
      const slider = root.querySelector('.kiin-protector-sheets__slider');
      const previous = root.querySelector('[data-wash-direction="-1"]');
      const next = root.querySelector('[data-wash-direction="1"]');
      if (!slider || !previous || !next) return;
      root.dataset.washReady = 'true';
      const update = () => {
        previous.disabled = slider.scrollLeft <= 5;
        next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5;
      };
      [previous, next].forEach(button => button.addEventListener('click', () => {
        slider.scrollBy({left: Number(button.dataset.washDirection) * slider.clientWidth * .8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      slider.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(slider);
      update();
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiin-towel-washcloth-draft"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const current = new URL(window.location.href);
    if (current.searchParams.get('view') !== 'hooded-towels') return;
    const handles = new Set(['hooded-towels','hooded-towel-oat','hooded-towel-chocolate','hooded-towel-buttercup','hooded-towel-sage','hooded-towel-sky','hooded-towel-lilac','hooded-towel-peony']);
    document.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const url = new URL(link.href, window.location.origin);
      const handle = url.pathname.match(/^\/products\/([^/]+)\/?$/)?.[1];
      if (url.origin !== window.location.origin || !handles.has(handle)) return;
      url.searchParams.set('view', 'hooded-towels');
      url.searchParams.set('preview_theme_id', '189330882805');
      link.href = url.href;
    }, true);
  })();
(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('.kiin-towel-wash').forEach(root => {
      if (root.dataset.washReady) return;
      const slider = root.querySelector('.kiin-towel-wash__slider');
      const previous = root.querySelector('[data-wash-direction="-1"]');
      const next = root.querySelector('[data-wash-direction="1"]');
      if (!slider || !previous || !next) return;
      root.dataset.washReady = 'true';
      const update = () => {
        previous.disabled = slider.scrollLeft <= 5;
        next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5;
      };
      [previous, next].forEach(button => button.addEventListener('click', () => {
        slider.scrollBy({left: Number(button.dataset.washDirection) * slider.clientWidth * .8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      slider.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(slider);
      update();
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiin-wash-cloth-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('.kiin-cloth-towels').forEach(root => {
      if (root.dataset.washReady) return;
      const slider = root.querySelector('.kiin-cloth-towels__slider');
      const previous = root.querySelector('[data-wash-direction="-1"]');
      const next = root.querySelector('[data-wash-direction="1"]');
      if (!slider || !previous || !next) return;
      root.dataset.washReady = 'true';
      const update = () => {
        previous.disabled = slider.scrollLeft <= 5;
        next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5;
      };
      [previous, next].forEach(button => button.addEventListener('click', () => {
        slider.scrollBy({left: Number(button.dataset.washDirection) * slider.clientWidth * .8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      slider.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(slider);
      update();
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
